import styles from "@store/Components/Store/StoreProductDetailsView/styles";
import { css } from "styled-components";


Object.assign(styles, {
    detailQtyInnerWrapper: {
        ...styles.detailQtyInnerWrapper,
        css: css`
            ${styles.detailQtyInnerWrapper?.css ?? ""}
            gap: 0.5em;
        `
    }
} as typeof styles);
